export default {
    plateOrders: [],
    plateOrdersLoading: false,
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters
}

function setInitialFilters() {
    return {
        status: 10,
    }
}